import React from "react";

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Us</h2>
            <p className="about-paragraph">
              At Illinois Touch of Family Healthcare LLC, we believe in providing
              compassionate, patient-centered care to individuals and families throughout
              Illinois. Our experienced healthcare professionals are dedicated to promoting
              health and wellness in our community.
            </p>
            <p className="about-paragraph">
              We understand that each patient is unique, and we take the time to listen
              to your concerns and develop personalized treatment plans. Our goal is to
              build lasting relationships with our patients based on trust, respect, and
              excellent care.
            </p>
            <div className="about-values">
              <div className="value-item">
                <h3 className="value-title">Quality Care</h3>
                <p>Evidence-based medicine delivered with excellence</p>
              </div>
              <div className="value-item">
                <h3 className="value-title">Compassion</h3>
                <p>Treating every patient with dignity and respect</p>
              </div>
              <div className="value-item">
                <h3 className="value-title">Accessibility</h3>
                <p>Convenient appointments and responsive care</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
